import React, { Component } from "react";
import http from "../Http/Http";
import "./Transfer.css";

class Transfer extends Component {
  constructor() {
    super();

    this.state = {
      name: "",
      phoneNumber: "",
      amount: "",
      description: "",
      errors: {
        amount: false,
        amountTooLow: false,
        amountTooHigh: false
      },
      isSubmitted: false
    };

    this.validateForm = this.validateForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.transfer = this.transfer.bind(this);
  }

  componentDidMount() {
    const { to } = this.props.match.params;

    http
      .get(`/wallet/$${to}`)
      .then(response => {
        // get the default signer from the response
        const signerId = response.data.default;

        if (signerId) {
          return signerId;
        } else {
          throw Error("No default signer");
        }
      })
      .then(signerId => {
        return http.get(`/signer/${signerId}`);
      })
      .then(response => {
        const name = response.data.labels.firstName;

        if (name) {
          this.setState({ name, phoneNumber: to });
        } else {
          throw Error("No name configured for this signer");
        }
      })
      .catch(() => {});
  }

  handleChange(event) {
    const target = event.target;

    this.setState(
      {
        [target.name]: target.value
      },
      () => {
        if (this.state.isSubmitted) {
          this.validateForm();
        }
      }
    );
  }

  validateForm(onValidForm) {
    const amount = parseInt(this.state.amount, 10);

    const errors = {
      amount: !amount,
      amountTooLow: !!amount && amount < 0,
      amountTooHigh: !!amount && amount > 1000000
    };

    this.setState({ errors });

    const errorKeys = Object.keys(errors).filter(key => errors[key]);

    // invoke callback function when form has no errors
    if (onValidForm && errorKeys.length === 0) {
      onValidForm();
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ isSubmitted: true });

    this.validateForm(this.transfer);
  }

  transfer() {
    const { phoneNumber, amount, description } = this.state;

    this.props.history.push(
      `/transferir/${phoneNumber}/${amount}/${encodeURIComponent(description)}`
    );
  }

  render() {
    const { amount, description, name, phoneNumber, errors } = this.state;

    return (
      <form
        className="transfer"
        noValidate
        action=""
        onSubmit={this.handleSubmit}
      >
        <h1 className="transfer-title">New transfer</h1>
        <div className="transfer-to-panel">
          <span className="transfer-to-name">{name}</span>
          <span className="transfer-to-phone">+{phoneNumber}</span>
        </div>
        <div className="transfer-form">
          <div className="transfer-input-group">
            <label className="transfer-label" htmlFor="amount">
              Monto
            </label>
            <div className="transfer-amount-input-group">
              <span className="transfer-input-amount-prefix">COP</span>
              <input
                className="transfer-input-amount"
                id="amount"
                name="amount"
                type="number"
                pattern="[0-9]*"
                placeholder="0"
                value={amount}
                onChange={this.handleChange}
                aria-invalid={errors.amount}
                autoComplete="off"
              />
            </div>
          </div>
          {errors.amount && (
            <div className="transfer-input-error" aria-live="polite">
              Ingrese una monto válida
            </div>
          )}
          {errors.amountTooLow && (
            <div className="transfer-input-error" aria-live="polite">
              Ingrese un monto superior a 0
            </div>
          )}
          {errors.amountTooHigh && (
            <div className="transfer-input-error" aria-live="polite">
              Ingrese un monto inferior a 1.000.000
            </div>
          )}
          <div className="transfer-input-group">
            <label className="transfer-label" htmlFor="description">
              Descripción (opcional)
            </label>
            <textarea
              className="transfer-input-description"
              id="description"
              name="description"
              placeholder="Ingrese una descripción"
              value={description}
              onChange={this.handleChange}
              autoComplete="off"
            />
          </div>
          <button className="transfer-submit button-green">Continuar</button>
        </div>
      </form>
    );
  }
}

export default Transfer;



// WEBPACK FOOTER //
// ./src/Transfer/Transfer.js